import React from "react";
import {
  LineChart, Line,
  BarChart, Bar,
  XAxis, YAxis, Tooltip, CartesianGrid,
  ResponsiveContainer, Legend
} from "recharts";
import { Card, Row, Col } from "react-bootstrap";

const productionData = [
  { month: "Jan", units: 120, target: 150 },
  { month: "Feb", units: 140, target: 150 },
  { month: "Mar", units: 160, target: 150 },
  { month: "Apr", units: 180, target: 160 },
  { month: "May", units: 130, target: 160 },
];

const inventoryData = [
  { item: "Steel", qty: 1200 },
  { item: "Wood", qty: 800 },
  { item: "Paint", qty: 500 },
  { item: "Hardware", qty: 300 },
];

const ordersData = [
  { status: "Pending", value: 20 },
  { status: "In Process", value: 35 },
  { status: "Completed", value: 50 },
  { status: "Delayed", value: 5 },
];

export default function ManufacturingDashboard() {
  return (
    <div className="container mt-4">

      <h3 className="fw-bold mb-4">Manufacturing ERP Dashboard</h3>

      {/* KPI CARDS */}
      <Row className="mb-4">
        <Col md={3}>
          <Card className="shadow-sm">
            <Card.Body>
              <h6>Total Production (This Month)</h6>
              <h3>18,450 Units</h3>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3}>
          <Card className="shadow-sm">
            <Card.Body>
              <h6>Orders In Process</h6>
              <h3>35</h3>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3}>
          <Card className="shadow-sm">
            <Card.Body>
              <h6>Inventory Value</h6>
              <h3>₹12,40,000</h3>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3}>
          <Card className="shadow-sm">
            <Card.Body>
              <h6>Pending Dispatch</h6>
              <h3>14 Orders</h3>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* PRODUCTION TREND */}
      <Card className="shadow-sm mb-4">
        <Card.Header className="fw-bold">Monthly Production Trend</Card.Header>
        <Card.Body style={{ height: 300 }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={productionData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Legend />

              <Line type="monotone" dataKey="units" stroke="#007bff" strokeWidth={3} />
              <Line type="monotone" dataKey="target" stroke="#28a745" strokeWidth={3} />
            </LineChart>
          </ResponsiveContainer>
        </Card.Body>
      </Card>

      <Row>
        {/* INVENTORY */}
        <Col md={6}>
          <Card className="shadow-sm mb-4">
            <Card.Header className="fw-bold">Inventory Stock Levels</Card.Header>
            <Card.Body style={{ height: 300 }}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={inventoryData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="item" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="qty" fill="#17a2b8" />
                </BarChart>
              </ResponsiveContainer>
            </Card.Body>
          </Card>
        </Col>

        {/* ORDER STATUS */}
        <Col md={6}>
          <Card className="shadow-sm mb-4">
            <Card.Header className="fw-bold">Order Status Overview</Card.Header>
            <Card.Body style={{ height: 300 }}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={ordersData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="status" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="value" fill="#ffc107" />
                </BarChart>
              </ResponsiveContainer>
            </Card.Body>
          </Card>
        </Col>
      </Row>

    </div>
  );
}
